export { FiltersService } from './filters.service';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/filters/services/index.ts